if (!customElements.get('canopy-sticky-cart')) {
  class CanopyStickyCart extends HTMLElement {
    connectedCallback() {
      const targetId = this.dataset.observe;
      const target = targetId && document.getElementById(targetId);
      if (!target) return;

      this.observer = new IntersectionObserver(
        (entries) => {
          const entry = entries[0];
          this.classList.toggle('is-visible', !entry.isIntersecting && entry.boundingClientRect.top < 0);
        },
        { threshold: 0 }
      );
      this.observer.observe(target);
    }

    disconnectedCallback() {
      if (this.observer) this.observer.disconnect();
    }
  }

  customElements.define('canopy-sticky-cart', CanopyStickyCart);
}

if (!customElements.get('canopy-review-carousel')) {
  class CanopyReviewCarousel extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.canopy-review-carousel__track');
      this.wrap = this.closest('.canopy-review-carousel-wrap');
      if (!this.track || !this.wrap) return;

      this.dotsContainer = this.wrap.querySelector('.canopy-review-carousel__dots');
      this.prevButton = this.wrap.querySelector('[data-direction="-1"]');
      this.nextButton = this.wrap.querySelector('[data-direction="1"]');
      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      this.buildDots();
      this.bindControls();
      this.updateActiveDot();

      this.track.addEventListener('scroll', () => this.onScroll(), { passive: true });
      window.addEventListener('resize', () => this.buildDots());

      if (!this.reducedMotion) this.startAutoplay();
      ['pointerdown', 'touchstart', 'mouseenter'].forEach((evt) =>
        this.addEventListener(evt, () => this.pauseAutoplay())
      );
      this.addEventListener('mouseleave', () => this.startAutoplay());
    }

    disconnectedCallback() {
      this.pauseAutoplay();
    }

    get pageCount() {
      return Math.max(1, Math.round(this.track.scrollWidth / this.track.clientWidth));
    }

    buildDots() {
      if (!this.dotsContainer) return;
      const count = this.pageCount;
      this.dotsContainer.innerHTML = '';
      for (let i = 0; i < count; i += 1) {
        const dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'canopy-review-carousel__dot';
        dot.setAttribute('aria-label', `Go to review ${i + 1}`);
        dot.addEventListener('click', () => this.goToPage(i));
        this.dotsContainer.appendChild(dot);
      }
      this.updateActiveDot();
    }

    bindControls() {
      if (this.prevButton) this.prevButton.addEventListener('click', () => this.step(-1));
      if (this.nextButton) this.nextButton.addEventListener('click', () => this.step(1));
    }

    step(direction) {
      this.track.scrollBy({ left: direction * this.track.clientWidth, behavior: 'smooth' });
    }

    goToPage(index) {
      this.track.scrollTo({ left: index * this.track.clientWidth, behavior: 'smooth' });
    }

    onScroll() {
      window.clearTimeout(this._scrollTimeout);
      this._scrollTimeout = window.setTimeout(() => this.updateActiveDot(), 80);
    }

    updateActiveDot() {
      if (!this.dotsContainer) return;
      const index = Math.round(this.track.scrollLeft / this.track.clientWidth);
      this.dotsContainer.querySelectorAll('.canopy-review-carousel__dot').forEach((dot, i) => {
        dot.classList.toggle('is-active', i === index);
      });
    }

    startAutoplay() {
      this.pauseAutoplay();
      this.autoplayId = window.setInterval(() => {
        const atEnd = this.track.scrollLeft + this.track.clientWidth >= this.track.scrollWidth - 4;
        if (atEnd) {
          this.track.scrollTo({ left: 0, behavior: 'smooth' });
        } else {
          this.step(1);
        }
      }, 4500);
    }

    pauseAutoplay() {
      if (this.autoplayId) window.clearInterval(this.autoplayId);
    }
  }

  customElements.define('canopy-review-carousel', CanopyReviewCarousel);
}
